export const BarChart = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="15" width="6" height="14" stroke="currentColor" stroke-width="2"/>
<rect x="20" y="7" width="6" height="22" stroke="currentColor" stroke-width="2"/>
<path d="M30 29H4C3.44771 29 3 28.5523 3 28V2" stroke="currentColor" stroke-width="2"/>
</svg>`;
